import classes from '@/components/Shares/Table.module.css';
import { useLingui } from '@lingui/react';
import { Paper, ScrollArea, Table } from '@mantine/core';
import { GameTableRow } from './GameTableRow';
export const GameTable: React.FC = () => {
  const {
    i18n
  } = useLingui();
  const ths = <Table.Tr>
      <Table.Th visibleFrom="lg" fz="xs" miw={170}>
        {i18n._('Rank')}
      </Table.Th>
      <Table.Th fz="xs" miw={160}>
        {i18n._('Player')}
      </Table.Th>
      <Table.Th visibleFrom="sm" fz="xs" miw={120}>
        {i18n._('Date')}
      </Table.Th>
      <Table.Th fz="xs" miw={100}>
        {i18n._('Wager')}
      </Table.Th>
      <Table.Th visibleFrom="sm" fz="xs" miw={100}>
        {i18n._('Multiplier')}
      </Table.Th>
      <Table.Th fz="xs" ta={{
      base: 'right',
      sm: 'left'
    }}>
        {i18n._('Payout')}
      </Table.Th>
    </Table.Tr>;
  return <Paper p={10} bg="var(--bg-200)">
      <ScrollArea scrollbars="y" h={480}>
        <Table.ScrollContainer minWidth={300}>
          <Table striped classNames={classes}>
            <Table.Thead>{ths}</Table.Thead>
            <Table.Tbody>{GameTableRow}</Table.Tbody>
          </Table>
        </Table.ScrollContainer>
      </ScrollArea>
    </Paper>;
};